import moment from 'moment';
import {inlineSchema} from './utils';
import i18n from '../i18n/index';
import * as Member from './membership';
import * as Transaction from './transaction';

export default function () {
  return {
    payment_id: {type: 'id', required: true},
    created_at: {type: 'datetime', readonly: true},
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'},

    payment_status: {
      type: 'select',
      items: ['status.pending', 'status.success', 'status.failed'],
      default: 'pending',
    },
    tags: [],

    member: {
      type: 'schema',
      schema: Member,
      external: true,
      required: true,
      list: true,
      display(model, index, fieldSpec, schema, columns) {
        return Member.title.call(this, model.member, Member);
      },
    },
    gateway_type: {type: 'select', items: ['payment.stripe', 'payment.paypal'], required: true}, //   stripe / paypal


    //  IF FAIL
    // payment_status: { type: String, default: 'pending' }, //  pending, success, fail
    err_codes: {
      label: 'fields.payment_gateway_err',
      type: 'array', readonly: true,
      itemType: {
        type: 'schema', schema: inlineSchema({
          created_at: {type: 'datetime', readonly: true},
          err_code: {},
        }),
      },
    },

    //  IF SUCCESS
    payment_refId: {type: String}, //  from payment gateway

    //  Everything returned from payment gateway
    gateway_backup_data: [{
      created_at: {type: 'datetime', readonly: true},
      data: {},
    }],
    gateway_responded_at: 'datetime', //  check loading performance of payment gateway

    //  Store original data, STATIC, resistent to change *****
    details: {},

    //  Purchase of payment with cash
    currency_type: {
      type: 'select',
      items: ['fields.currency.cash_hkd', 'fields.currency.cash_usd'],
      required: true,
    },
    currency_amount: {type: 'number', required: true},


    //  transaction ( push when payment success / refunded boz of changes in diamond)
    transactions: {
      type: 'array',
      itemType: {type: 'schema', schema: Transaction, readonly: true},
    },

    //  refund
    // refund_status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'inactive'},
    refund_at: {type: 'datetime', list: false},
  };
}



// WEBPACK FOOTER //
// ./src/schemas/payment_db.js